const initialState = {
    paymentDetailsError: {
      caseNoErr: {},
      paymentTypeErr: {},
      amountErr: {},
      paymentNoErr: {},
      chequeDateErr:{},
      // paymentDateErr:{}
    }
  };
  const clientPaymentErrorReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'PAYMENTDETAILSERROR':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            paymentDetailsError: action.payload
          };
        }
      default:
        return state;
    }
  };
  
  export default clientPaymentErrorReducer;